import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import QantasFrequentFlyerDetailed from 'components/QantasFrequentFlyerDetailed'
import QantasFrequentFlyerSimple from 'components/QantasFrequentFlyerSimple'
import { validateQffForm } from 'utilities/formValidator.util'
import {
  setQffDetails,
  setResponseMessage,
  submitQff,
  setFieldErrors,
} from './actions'
import {
  QFF_FIRST_NAME_KEY,
  QFF_LAST_NAME_KEY,
  QFF_EMAIL_KEY,
  QFF_REFERENCE_KEY,
  QFF_NUMBER_KEY,
} from './constants'

class QantasFrequentFlyerContainer extends Component {
  constructor(props) {
    super(props)
    // We handle state here locally as storing these in Redux for onChange events is very expensive!
    this.state = {
      fieldValues: {
        [QFF_FIRST_NAME_KEY]: props.previouslySetDetails[QFF_FIRST_NAME_KEY] || '',
        [QFF_LAST_NAME_KEY]: props.previouslySetDetails[QFF_LAST_NAME_KEY] || '',
        [QFF_EMAIL_KEY]: props.previouslySetDetails[QFF_EMAIL_KEY] || '',
        [QFF_REFERENCE_KEY]: props.previouslySetDetails[QFF_REFERENCE_KEY] || '',
        [QFF_NUMBER_KEY]: '',
      },
    }
  }

  /* Full Name Handlers */
  onFieldChange = (value, fieldname) => {
    this.setState({
      fieldValues: {
        ...this.state.fieldValues,
        [fieldname]: value,
      },
    })
  }
  onFieldChangeHandler = event => this.onFieldChange(event.target.value, event.target.name)
  onSelectChangeHandler = (event) => {
    this.onFieldChange(event.target.value, event.target.name)
    this.props.setQffDetails({ [event.target.name]: event.target.value })
  }

  onFieldBlur = (event) => {
    if (this.props.fieldValues[event.target.name] !== this.state.fieldValues[event.target.name]) {
      this.props.setQffDetails({ [event.target.name]: event.target.value })
    }
  }

  /* Handle Submission */
  onQffSubmit = (event) => {
    event.preventDefault()
    this.props.setResponseMessage('')

    const valid = validateQffForm(this.state.fieldValues)

    if (valid === true) {
      /* Clear any form errors */
      this.props.setFieldErrors({})
      this.props.submitQff(this.state.fieldValues, this.props.nextPage)
    } else {
      this.props.setFieldErrors(valid)
    }
  }

  render() {
    const {
      qffReducer,
      qffText,
      fieldError,
      firstNameLabel,
      lastNameLabel,
      emailLabel,
      referenceLabel,
      qffLabel,
      submitLabel,
      termsText,
      successText,
      isSimplePage,
    } = this.props
    const {
      isLoading,
      success,
      message,
    } = qffReducer

    if (isSimplePage) {
      return (
        <QantasFrequentFlyerSimple
          qffReducer={qffReducer}
          fieldError={fieldError}
          onSubmit={this.onQffSubmit}
          onFieldChangeHandler={this.onFieldChangeHandler}
          onFieldBlur={this.onFieldBlur}
          clearEmailErrors={this.clearEmailErrors}
          fieldValues={this.state.fieldValues}
          isLoading={isLoading}
          isFormComplete={success}
          successText={successText}
          message={message}
          qffText={qffText}
        />
      )
    }
    return (
      <QantasFrequentFlyerDetailed
        qffReducer={qffReducer}
        fieldError={fieldError}
        onSubmit={this.onQffSubmit}
        onFieldChangeHandler={this.onFieldChangeHandler}
        onFieldBlur={this.onFieldBlur}
        clearEmailErrors={this.clearEmailErrors}
        fieldValues={this.state.fieldValues}
        firstNameLabel={firstNameLabel}
        lastNameLabel={lastNameLabel}
        emailLabel={emailLabel}
        referenceLabel={referenceLabel}
        qffLabel={qffLabel}
        submitLabel={submitLabel}
        isLoading={isLoading}
        isFormComplete={success}
        termsText={termsText}
        successText={successText}
        message={message}
      />
    )
  }
}

QantasFrequentFlyerContainer.propTypes = {
  qffReducer: PropTypes.shape({
    isLoading: PropTypes.bool,
    success: PropTypes.bool,
    message: PropTypes.string,
  }),
  fieldValues: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
  }),
  previouslySetDetails: PropTypes.shape({
    [QFF_FIRST_NAME_KEY]: PropTypes.string,
    [QFF_LAST_NAME_KEY]: PropTypes.string,
    [QFF_EMAIL_KEY]: PropTypes.string,
    [QFF_REFERENCE_KEY]: PropTypes.string,
  }),
  fieldError: PropTypes.object,
  firstNameLabel: PropTypes.string,
  lastNameLabel: PropTypes.string,
  emailLabel: PropTypes.string,
  referenceLabel: PropTypes.string,
  qffLabel: PropTypes.string,
  submitLabel: PropTypes.string,
  termsText: PropTypes.string,
  successText: PropTypes.string,
  nextPage: PropTypes.string,
  isSimplePage: PropTypes.bool,
  qffText: PropTypes.string,

  setResponseMessage: PropTypes.func,
  submitQff: PropTypes.func,
  setFieldErrors: PropTypes.func,
  setQffDetails: PropTypes.func,
}

QantasFrequentFlyerContainer.defaultProps = {
  qffReducer: {
    isLoading: false,
    success: false,
    message: '',
  },
  fieldValues: {},
  fieldError: {},
  firstNameLabel: 'Your First Name',
  lastNameLabel: 'Your Last Name',
  emailLabel: 'Your Email',
  referenceLabel: 'Your Kogan Internet Customer Reference',
  qffLabel: 'Your Qantas Frequent Flyer Number (only the digits)',
  previouslySetDetails: {
    [QFF_FIRST_NAME_KEY]: '',
    [QFF_LAST_NAME_KEY]: '',
    [QFF_EMAIL_KEY]: '',
    [QFF_REFERENCE_KEY]: '',
  },
  submitLabel: 'Register Details',
  termsText: null,
  successText: null,
  nextPage: null,
  isSimplePage: false,
  qffText: '',

  setResponseMessage: f => f,
  submitQff: f => f,
  setFieldErrors: f => f,
  setQffDetails: f => f,
}

function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    qffReducer: state.qffReducer,
    fieldValues: state.qffReducer.fieldValues,
    fieldError: state.qffReducer.fieldError,
    previouslySetDetails: {
      [QFF_FIRST_NAME_KEY]: state.checkoutReducer.personalFieldValues.first_name,
      [QFF_LAST_NAME_KEY]: state.checkoutReducer.personalFieldValues.last_name,
      [QFF_EMAIL_KEY]: state.checkoutReducer.email,
      [QFF_REFERENCE_KEY]: state.checkoutReducer.reference,
    },
  }
}

// Anything returned from this function will end up as props
function mapDispatchToProps(dispatch) {
  // Whenever dispatch is called the result should be passed
  // to all of the reducers
  return bindActionCreators(
    {
      setQffDetails,
      setResponseMessage,
      submitQff,
      setFieldErrors,
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(QantasFrequentFlyerContainer)



// WEBPACK FOOTER //
// ./containers/QantasFrequentFlyer/index.jsx